import { useEffect } from 'react';

/**
 * ThemeLoader - Dynamically loads theme CSS files only for authenticated users
 * This component should be used within the AppLayout to ensure theme tokens
 * are only available in the authenticated app, not on public pages.
 */
function ThemeLoader() {
  useEffect(() => {
    // Load theme CSS files dynamically
    import('../theme/buttons.css');
    import('../theme');
  }, []);

  return null; // This component doesn't render anything
}

export default ThemeLoader;
